import React from 'react'
import { HubCompanyPublicOrgansManagement } from 'domain/feature/hub/company/public-organs'

export const HubCompanyPublicOrgansPage = (): JSX.Element => {
  return (
    <HubCompanyPublicOrgansManagement />
  )
}

